<template>
  <section class="box box--small-padding">
    <FetchJson :url="url" @fetched="onFetched">
      <template #default="{ json, loading }">
        <h2 class="box__header title-24">Способ подачи заявлений</h2>
        <div class="layout--horizontal" v-if="!loading">
          <ScalarIndicator
            title="Всего направлено заявлений"
            :value="json.applicationsTotal"
          />
          <div :key="componentKey" class="chart__content layout--horizontal">
            <DonutChart
              :series="getRates(json)"
              :labels="sourcesApplications"
              :colors="colors"
              :height="90"
              :legendOffsetX="85"
              :legendOffsetY="-18"
              :tooltipTitleFormatter="() => 'Количество заявлений: '"
            />
          </div>
        </div>
      </template>
    </FetchJson>
  </section>
</template>

<script>
import { ref, toRefs, computed } from "vue";
import { dateToString } from "@/modules/date";
import ScalarIndicator from "@/components/infoblocks/ScalarIndicator";
import DonutChart from "@/components/common/DonutChart";

const sourcesApplications = ["ПГУ", "МФЦ", "Остальные"];
const colors = ["#518CFF", "#32E1CC", "#FFAA1F"];

export default {
  props: {
    filter: {
      type: Object,
      required: true,
    },
  },
  components: {
    DonutChart,
    ScalarIndicator,
  },
  setup(props) {
    const filter = toRefs(props.filter);
    const componentKey = ref(Date.now());
    const url = computed(
      () =>
        `applications/send-method-total?from=${dateToString(
          filter.from.value
        )}&to=${dateToString(filter.to.value)}&territory=${
          filter.territory.value.alias || ""
        }`
    );
    const getRates = function (tableData) {
      const mfc = tableData.mfc;
      const pgu = tableData.pgu;
      const other = tableData.other;

      return [pgu, mfc, other];
    };

    return {
      componentKey,
      url,
      getRates,
      sourcesApplications,
      colors,
    };
  },
  methods: {
    onFetched() {
      this.labels = sourcesApplications;
      this.componentKey = Date.now(); // Tell Vue to re-create the component.
    },
  },
};
</script>
